// @flow
import { createReducer } from 'redux-act';

import type { DiscountState as State } from '../../types';
import { set } from '../actions/discount';

const initialState: State = {
  codes: [],
  excludes: {},
  price_virtual_currencies: {},
};

function setHandler(state: State, newState: State): State {
  return newState;
}

export default (createReducer(
  {
    [set.toString()]: setHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
